module.exports = __webpack_public_path__ + "static/media/error.5e81b832.png";